import { render } from "./ZDFPlayer.vue?vue&type=template&id=cdd51d34"
import script from "./ZDFPlayer.vue?vue&type=script&lang=js"
export * from "./ZDFPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__